// styles imports
import './CircleGraph.scss';

export const Comment = `
	/**
	 *
	 * props の定義
	 *
	 * [set]
	 * 		id				...	スタイルシートid指定の文字列
	 * 		class			...	スタイルシートクラス指定の文字列
	 *
	 * [act]
	 * 		onclick			...	クリック時に実行したい処理
	 */
	`

export const CircleGraph = (props) => {
	return (
			<div
				className={"circle-graph " + (props.className ? props.className : "")} 
				style={{ '--rate': `${props.rate}`, '--radius': `${props.radius}`, '--thickness': `${props.thickness}` }}
				>
				<div className="percent" >
					<svg>
						<circle className="base" cx={ (props.radius +  props.thickness) } cy={ (props.radius +  props.thickness) } r={ (props.radius) }></circle>
						<circle className="line" cx={ props.radius +  props.thickness } cy={ props.radius +  props.thickness } r={ props.radius }></circle>
					</svg>
				</div>
			</div>
	);
}
export default CircleGraph